import { render, staticRenderFns } from "./RegistGroup.vue?vue&type=template&id=080a097d&scoped=true&"
import script from "./RegistGroup.vue?vue&type=script&lang=js&"
export * from "./RegistGroup.vue?vue&type=script&lang=js&"
import style0 from "./RegistGroup.vue?vue&type=style&index=0&id=080a097d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "080a097d",
  null
  
)

export default component.exports